import { maxBy } from "lodash";

import {
  ExperiencePageTargetingDto,
  ExperiencePageTargetingFe,
} from "@intelligems/ig-types";
import * as rtk from "@reduxjs/toolkit";
import { type PayloadAction } from "@reduxjs/toolkit";

import { initialIPageTargetingState } from "../types/pageTargeting";

const pageTargetingSlice = rtk.createSlice({
  name: "pageTargeting",
  initialState: initialIPageTargetingState,
  reducers: {
    resetPageTargeting: (draft) => {
      draft = initialIPageTargetingState;
      return draft;
    },
    resetPageTargetingToStored: (draft) => {
      draft = { ...draft, pageTargeting: draft.storedPageTargeting };
      return draft;
    },
    initPageTargeting: (
      draft,
      action: PayloadAction<{ pageTargeting: ExperiencePageTargetingDto[] }>
    ) => {
      draft.isSuccess = true;
      draft.pageTargeting = action.payload.pageTargeting;
      draft.storedPageTargeting = action.payload.pageTargeting;
    },
    deletePageTargetingRow: (
      draft,
      action: PayloadAction<{ index: number }>
    ) => {
      if (draft.pageTargeting) {
        draft.pageTargeting.splice(action.payload.index, 1);
        draft.pageTargeting = draft.pageTargeting.map((item, i) => {
          return {
            ...item,
            order: i,
          };
        });
      }
      return draft;
    },
    updatePageTargetingRow: (
      draft,
      action: PayloadAction<{
        updatedPageTargeting: ExperiencePageTargetingFe;
        index: number;
      }>
    ) => {
      if (draft.pageTargeting) {
        if (action.payload.index >= 0) {
          draft.pageTargeting[action.payload.index] =
            action.payload.updatedPageTargeting;
        } else {
          draft.pageTargeting.push({
            ...action.payload.updatedPageTargeting,
            order:
              draft.pageTargeting.length === 0
                ? 0
                : maxBy(draft.pageTargeting, "order")!.order + 1,
          });
        }
      }
      return draft;
    },
  },
  selectors: {
    selectedPageTargetingState: (state) => state,
    selectedPageTargeting: (state) => state.pageTargeting,
    selectedStoredPageTargeting: (state) => state.storedPageTargeting,
  },
});

export const {
  resetPageTargeting,
  initPageTargeting,
  deletePageTargetingRow,
  updatePageTargetingRow,
  resetPageTargetingToStored,
} = pageTargetingSlice.actions;

export const pageTargetingReducer = pageTargetingSlice.reducer;
export const {
  selectedPageTargetingState,
  selectedStoredPageTargeting,
  selectedPageTargeting,
} = pageTargetingSlice.selectors;
